import { useState, useCallback } from 'react';

export const useStatusFilter = () => {
  const [selectedStatus, setSelectedStatus] = useState<string | null>(null);

  const handleStatusChange = useCallback((status: string) => {
    setSelectedStatus(status);
  }, []);

  return {
    selectedStatus,
    handleStatusChange,
  };
};
